import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LoginComponent } from './login/login.component';
import { AdminPanelComponent } from './menu/admin/admin-panel/admin-panel.component';
import { JamesAdminComponent } from './menu/admin/james-admin/james-admin.component';
import { ProtheusAdminComponent } from './menu/admin/protheus-admin/protheus-admin.component';
import { DatabaseComponent } from './menu/database/database.component';
import { HomeComponent } from './menu/home/home.component';
import { JamesbComponent } from './menu/jamesb/jamesb.component';
import { MenuComponent } from './menu/menu.component';
import { ProtheusComponent } from './menu/protheus/protheus.component';
import { QueryAnalyzerComponent } from './menu/query-analyzer/query-analyzer.component'
import { QueryChatComponent } from './menu/query-chat/query-chat.component';
import { SupportComponent } from './menu/support/support.component';
import { TotvsNewsPreviewComponent } from './menu/totvs-news-preview/totvs-news-preview.component';
import { QueryManagerComponent } from './menu/query-manager/query-manager.component';
import { StatusComponent } from './menu/status/status/status.component';
import { AnalysisDetailsComponent } from './menu/query-analyzer/components/analysis-details/analysis-details.component';
import { DependencyTrackComponent } from './menu/dependency-track/dependency-track.component';
import { ApiKeysComponent } from './menu/api-keys/api-keys.component';
import { DocumentaAiComponent } from './menu/admin/mcp-admin/documenta-ai.component';
import { McpReportsGuard } from './menu/admin/mcp-admin/guards/mcp-reports.guard';
import { AreaTribeAdminComponent } from './menu/admin/area-tribe-admin/area-tribe-admin.component';
import { UsersAdminGuard } from './menu/admin/area-tribe-admin/guards/users-admin.guard';
import { UsersAccessComponent } from './menu/admin/area-tribe-admin/users-access/users-access.component';
import { StructureComponent } from './menu/admin/area-tribe-admin/structure/structure.component';
import { AccessAuditComponent } from './menu/admin/area-tribe-admin/access-audit/access-audit.component';
import { TribesComponent } from './menu/admin/area-tribe-admin/tribes/tribes.component';
import { smartReviewRoutes } from './menu/smart-review/smart-review.routes';
import { SonarExtractorComponent } from './menu/sonar-extractor/sonar-extractor.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'menu', component: MenuComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard], canLoad: [AuthGuard],
        children: [
          { 
            path: 'home', 
            component: HomeComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'database', 
            component: DatabaseComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'protheus', 
            component: ProtheusComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'query-analyzer', 
            component: QueryAnalyzerComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'query-analyzer/:id',
            component: AnalysisDetailsComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'chat', 
            component: QueryChatComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'test-manager', 
            component: QueryManagerComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'jamesbond', 
            component: JamesbComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'dependency-track', 
            component: DependencyTrackComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'api-keys',
            component: ApiKeysComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'sonar-extractor',
            component: SonarExtractorComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'totvs-news-preview',
            component: TotvsNewsPreviewComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'support', 
            component: SupportComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'status', 
            component: StatusComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'adminpanel', 
            component: AdminPanelComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          { 
            path: 'protheusAdmin', 
            component: ProtheusAdminComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'jamesbAdmin',
            component: JamesAdminComponent,
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          {
            path: 'usersAdmin',
            component: AreaTribeAdminComponent,
            canActivate: [UsersAdminGuard],
            canActivateChild: [AuthGuard], canLoad: [AuthGuard],
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'users' },
              { path: 'users', component: UsersAccessComponent },
              { path: 'areas', component: StructureComponent },
              { path: 'tribes', component: TribesComponent },
              { path: 'audit', component: AccessAuditComponent },
              { path: 'structure', redirectTo: 'areas' }
            ]
          },
          {
            path: 'mcp/reports/documenta-ai',
            component: DocumentaAiComponent,
            canActivate: [McpReportsGuard],
            data: { role: 'mcp:reports:documenta-ai' },
            canActivateChild: [AuthGuard], canLoad: [AuthGuard]
          },
          ...smartReviewRoutes
        ] },
  // { path: 'loginError', component: LoginErrorComponent },
  { path: '', pathMatch: 'full', canActivateChild: [AuthGuard], canLoad: [AuthGuard], redirectTo: '/menu/home',}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
